import React from 'react';
import DOMPurify from 'dompurify';
import parse, { domToReact } from 'html-react-parser';

const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'em',
  'h2',
  'h3',
  'h4',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  'span',
  'strong',
  'u',
  'ul'
];

const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id'];

export const normalizeToHttpsUrl = (value = '') => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('http://')) return `https://${trimmed.slice(7)}`;
  return trimmed;
};

const sanitizeHtml = (html = '') =>
  DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_ATTR: ['style'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form']
  });

export const renderSafeHtml = (html = '') => {
  const parserOptions = {
    replace: (node) => {
      if (!node || node.type !== 'tag' || !node.name || !node.attribs) {
        return undefined;
      }

      if (node.name === 'a') {
        const href = normalizeToHttpsUrl(node.attribs.href);
        if (!href || /^\s*javascript\s*:/i.test(href)) {
          return <span>{domToReact(node.children, parserOptions)}</span>;
        }

        return (
          <a
            href={href}
            target={node.attribs.target || '_blank'}
            rel={node.attribs.rel || 'noopener noreferrer'}
          >
            {domToReact(node.children, parserOptions)}
          </a>
        );
      }

      if (node.name === 'img') {
        const src = normalizeToHttpsUrl(node.attribs.src);
        if (!src || /^\s*javascript\s*:/i.test(src)) {
          return null;
        }

        return (
          <img
            src={src}
            alt={node.attribs.alt || ''}
            title={node.attribs.title || undefined}
            loading="lazy"
            decoding="async"
          />
        );
      }

      return undefined;
    }
  };

  return parse(sanitizeHtml(html), parserOptions);
};
